import { render } from "./tpl_menu.vue?vue&type=template&id=810401a0&scoped=true"
import script from "./tpl_menu.vue?vue&type=script&lang=js"
export * from "./tpl_menu.vue?vue&type=script&lang=js"

import "./tpl_menu.vue?vue&type=style&index=0&id=810401a0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810401a0"],['__file',"src/views/wap/template/tpl_menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "810401a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('810401a0', __exports__)) {
    console.log('reload')
    api.reload('810401a0', __exports__)
  }
  
  module.hot.accept("./tpl_menu.vue?vue&type=template&id=810401a0&scoped=true", () => {
    console.log('re-render')
    api.rerender('810401a0', render)
  })

}


export default __exports__